"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AddCircleOutlineRounded_1 = __importDefault(require("@mui/icons-material/AddCircleOutlineRounded"));
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const clsx_1 = __importDefault(require("clsx"));
const Button_1 = __importDefault(require("../../../global/Button/Button"));
const ArrayOfGroupsItem_1 = __importDefault(require("./ArrayOfGroupsItem"));
const arrayFieldsDragAndDrop_1 = require("../../../../utilities/arrayFieldsDragAndDrop/arrayFieldsDragAndDrop");
const ArrayOfGroups = (props) => {
    const { items, canAdd, disabled, onAddClick, idSchema, fixedItemCount } = props;
    const [isKeyboardNavigating, setIsKeyboardNavigating] = (0, react_1.useState)(false);
    const handleKeyDown = (event) => {
        if (event.code === 'Tab' || event.code === 'Space' || event.code === 'ArrowDown' || event.code === 'ArrowUp') {
            setIsKeyboardNavigating(true);
        }
    };
    const onBeforeCapture = (result) => {
        if (!isKeyboardNavigating) {
            // Add the class to minimise the dragged element before drag-and-drop starts calculating heights
            (0, arrayFieldsDragAndDrop_1.draggingElement)(result.draggableId, 'add');
        }
    };
    const onDragStart = (result) => {
        // Force focus on the element so that `recordChanges` fires and sets in motion all the other data updates
        (0, arrayFieldsDragAndDrop_1.focusDragHandle)(result.draggableId, 'focus');
    };
    const onDragEnd = (result) => {
        // Remove the temporary focus on draghandle that was needed to fire off `recordChanges`
        (0, arrayFieldsDragAndDrop_1.focusDragHandle)(result.draggableId, 'blur');
        // Result initial state
        (0, arrayFieldsDragAndDrop_1.draggingElement)(result.draggableId, 'remove');
        setIsKeyboardNavigating(false);
        (0, arrayFieldsDragAndDrop_1.reorderItems)(result, items);
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragStart: onDragStart, onDragEnd: onDragEnd, onBeforeCapture: onBeforeCapture },
            react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: `droppable-${idSchema.$id}`, isDropDisabled: disabled }, (dropProvided, snapshot) => (react_1.default.createElement("div", { className: (0, clsx_1.default)('drop-area mb-1', snapshot.isDraggingOver && 'is-dragging-over'), role: "group", ...dropProvided.droppableProps, ref: dropProvided.innerRef },
                items &&
                    items.map((element, index) => (react_1.default.createElement(ArrayOfGroupsItem_1.default, { key: element.key, element: element, fixedItemCount: fixedItemCount, index: index, disabled: items.length === 1 || disabled || items.length - fixedItemCount === 1 }))),
                dropProvided.placeholder)))),
        canAdd && (react_1.default.createElement("div", { className: "mt-1" },
            react_1.default.createElement(Button_1.default, { isDisabled: disabled, text: "Add", onClick: onAddClick, variant: "link", className: "!p-0", icon: react_1.default.createElement(AddCircleOutlineRounded_1.default, { className: "icon" }) })))));
};
exports.default = ArrayOfGroups;
